import { useBackend } from "../../services";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import { IArtist } from "./interfaces";
import {
  IGetPaginatedAttributeProps,
  IPublicGetPaginatedAttributeProps
} from "../attributes/interfaces";
import { useCollectionManager } from "../collections/useCollectionManager";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetArtists = (isPublic: boolean, setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const { getCurrentCollection } = useCollectionManager();
  const [currentUser] = useUser.useState();
  const getArtists = (parameters: IGetPaginatedAttributeProps) => get("artists", parameters);
  const getPublicArtists = (parameters: IPublicGetPaginatedAttributeProps) =>
    get("artists/shared/public", parameters);
  return useGetPaginatedAttributes<IArtist>(
    PageSizeHelper.artists(currentUser?.role ?? UserRole.common),
    isPublic ? getPublicArtists : getArtists,
    setLoading,
    DataStorage.artistStorage,
    isPublic,
    true,
    getCurrentCollection(isPublic)?.uuid
  );
};
